// extracted by mini-css-extract-plugin
export default {"game":"game_game__yi1Wr"};